// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1TeamSchema = z.object({
  id: z.number().int().describe("Unique identifier for the team"),
  name: z.coerce.string().describe("Name of the team"),
  color: z.coerce.string().describe("Team display color (hex code)"),
  emoji: z.nullable(z.coerce.string().describe("Team emoji")),
  external_id: z.nullable(z.coerce.string().describe("External ID for the team")),
  user_ids: z.optional(z.array(z.number().int()).describe("Array of user IDs in the team")),
  users: z.optional(z.array(z.unknown()).describe("Array of team user objects with details")),
  project_ids: z.optional(z.array(z.number().int()).describe("Array of project IDs associated with the team")),
});
